import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import { InView } from 'react-intersection-observer'
import Icon from '../controls/icon-control'
import IEventedComponent, { messageTypes } from './IEventedComponent'
import { ChapterChangedEvent, ScrollToTopEvent } from '../lib/messages'
import { MobileDeviceWidth } from '../lib/constants'
import isMobile from '../lib/is-mobile'

const Container = styled.div`
  background: ${colours.mediumBlue};
  color: ${colours.white};
  padding: 26px;

  @media (max-width: ${MobileDeviceWidth}px) {
    font-size: 18px;
    padding: 26px 18px;
  }
`

const FixedContainer = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
`

const InvertedHeader = styled.div`
  :hover {
    text-decoration: underline;
    color: ${colours.white};
  }
  cursor: pointer;
  font-weight: bold;
  background: ${colours.mediumBlue};
  color: ${colours.white};
  padding: 20px 26px 20px 26px;

  @media (max-width: ${MobileDeviceWidth}px) {
    display: none;
  }
`

const ClearHeader = styled.div`
  padding: 16px 26px 16px 26px;
  color: ${colours.mediumBlue};
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  background: white;
  font-size: 26px;
  @media (max-width: ${MobileDeviceWidth}px) {
    font-size: 18px;
    padding: 16px 18px 16px 18px;
  }
`

const Underlined = styled.span`
  text-decoration: underline;
`

interface IProps {
  stickyContent?: React.ReactNode
}

interface IState {
  visible: boolean
  chapterTitle: string
}

class StickyHeader extends IEventedComponent<IProps, IState> {
  state: IState = {
    visible: true,
    chapterTitle: ''
  }

  componentDidMount() {
    this.subscribe(messageTypes.onChapterChanged, this.handleActivateChapter)
  }

  handleActivateChapter = (message: ChapterChangedEvent) => {
    if (this.state.chapterTitle !== message.title) {
      this.setState({ chapterTitle: message.title })
    }
  }

  handleChange = (visible: boolean) => this.setState({ visible })

  handleScrollToTop = () => {
    this.publish<ScrollToTopEvent>(messageTypes.onScrollToTop, {})
  }

  renderFixedTitle() {
    const customStyle: any = {}
    if (isMobile() && !this.state.visible) {
      customStyle.position = 'fixed'
    }
    return (
      <FixedContainer style={customStyle}>
        {!this.state.visible && (
          <InvertedHeader onClick={this.handleScrollToTop}>
            <Icon icon="arrow-up" />
            <Underlined>Back to top</Underlined>
          </InvertedHeader>
        )}
        {this.state.chapterTitle && !this.state.visible && (
          <ClearHeader>{this.state.chapterTitle}</ClearHeader>
        )}
        {this.props.stickyContent}
      </FixedContainer>
    )
  }

  render() {
    return (
      <>
        <Container>{this.props.children}</Container>
        <InView onChange={this.handleChange}>
          <></>
        </InView>
        {this.renderFixedTitle()}
      </>
    )
  }
}

export default StickyHeader
